/* -------------------------------------------------------------------------- */
/*                           USED BY ALL PAGES                                */
/* -------------------------------------------------------------------------- */
import { convertCentsToDollars } from "frontend/components/helpers";

export const subscriptionDesc =
    "Your subscription unlocks unlimited downloads and editing, plus all apps and plugins. This purchase supports artists, so no attribution is required.";

export const licenseType = "subscription";

export const subscribeURL = "/subscribe/pro/";
export const subscribeTeamURL = "/subscribe/team/";
export const MonthlyIconSubscription = "Monthly Icon Subscription";
export const YearlyIconSubscription = "Yearly Icon Subscription";

export const checkoutFormHeader = "Subscription Options";

export const perMonth = "/month";
export const perYear = "/year";

export const initialForm = {
    name: "",
    address_zip: ""
};

export const svgSizes = {
    width: 60,
    height: 60
};

export const DisclaimerTextMonthly =
    "You will be charged now & monthly at this time when your account automatically renews. Cancel automatic renewal at any time.";

export const DisclaimerTextYearly =
    "You will be charged now & yearly at this time when your account automatically renews. Cancel automatic renewal at any time.";

/* -------------------------------------------------------------------------- */
/*                           NounPro                                          */
/* -------------------------------------------------------------------------- */

export const PRO_MONTHLY_PLAN = "pro-monthly";
export const PRO_YEARLY_PLAN = "pro-yearly";

// NounPro Confirmation Heading
export const nounProConfirmationHeading =
    "Thanks for Your NounPro Icon Subscription";

export const EDU_PER_YEAR_COST = 19.99;

/* -------------------------------------------------------------------------- */
/*                           NounPro for EDU                                  */
/* -------------------------------------------------------------------------- */

export const nounProEduPageTitle = "Get Started with NounPro for Education";
export const EDU_PRO_YEARLY_PLAN = "edu-yearly";

export const nounProEduConfirmationHeading =
    "Thanks for Your NounPro for Education Icon Subscription";

/* -------------------------------------------------------------------------- */
/*                           NounPro for Teams                                */
/* -------------------------------------------------------------------------- */

export const TEAM_YEARLY_PLAN = "team-yearly";
export const TEAM_MONTHLY_PLAN = "team-monthly";
export const perUserPerYear = "/member/year";
export const perUserPerMonth = "/member/month";

export const nounTeamConfirmationHeading =
    "Thanks for Your NounPro Team Icon Subscription";

/* -------------------------------------------------------------------------- */
/*                           PROMO CODE                                       */
/* -------------------------------------------------------------------------- */

export const toolTipMsg = "Remove promo code";
